import React from "react";
import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb";
import { useBreadcrumbs } from "./hooks";
import { useNavigate } from "react-router-dom";

export const Breadcrumbs: React.FC = () => {
    const navigate = useNavigate();
    const { getBreadcrumbs } = useBreadcrumbs();
    const { items } = getBreadcrumbs();

    return (
        <BreadcrumbGroup data-testid="breadcrums">
            {items.map(crumb => {
                return (
                    <Breadcrumb
                        key={crumb.text}
                        onClick={() => {
                            navigate(crumb.href);
                            crumb?.commandRedirect?.();
                        }}
                    >
                        {crumb.text}
                    </Breadcrumb>
                );
            })}
        </BreadcrumbGroup>
    );
};
